import CryptoJS from 'crypto-js';
// 从环境变量获取密钥和偏移量（生产环境建议从后端动态获取）
const KEY = CryptoJS.enc.Utf8.parse('7FkT3pQm8sZ2xY4v'); // 16位
const IV = CryptoJS.enc.Utf8.parse('9DcR6fBj2nH5gK1w');  // 16位

/**
 * AES加密
 * @param {string} data - 需要加密的数据
 * @returns {string} 加密后的字符串
 */
export function encrypt(data) {
  if (typeof data !== 'string') {
    data = JSON.stringify(data);
  }
  const encrypted = CryptoJS.AES.encrypt(
    data,
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return encrypted.toString();
}

/**
 * AES解密
 * @param {string} encryptedData - 需要解密的数据
 * @returns {string} 解密后的字符串
 */
export function decrypt(encryptedData) {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData,
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}
    